module.exports = __webpack_public_path__ + "img/sg.9eb47fe7.svg";